import React, { useState, useEffect } from "react";
import {
  PanelHeader,
  Button,
  InputGroup,
  MultiSelectDropdown,
  DropDown,
  useMultiSelectDropdown,
} from "@pushpress/shared-components";
import PropTypes from "prop-types";

const statusOptions = [
  {
    label: "No Show",
    value: "no-show",
  },
  {
    label: "Late Cancel",
    value: "late-cancel",
  },
  {
    label: "Charged",
    value: "charged",
  },
  {
    label: "Forgiven",
    value: "forgiven",
  },
];

const FiltersMenu = ({
  filters,
  applyFilters,
  closeMenu,
  persons,
  classes,
}) => {
  const [status, statusActions] = useMultiSelectDropdown(
    statusOptions,
    filters.status,
  );
  const [classType, classTypeActions] = useMultiSelectDropdown(
    classes,
    filters.classType,
  );
  const [person, setPerson] = useState(filters.person);

  const onSubmit = () => {
    applyFilters({
      person,
      status: status.map((s) => s.value),
      classType: classType.map((c) => c.value),
    });
  };

  return (
    <div className="pp_no_show_filters">
      <PanelHeader title="Filters">
        <PanelHeader.ActionMenu>
          <Button buttonType="secondary" text="Cancel" onClick={closeMenu} />
          <Button text="Save" onClick={onSubmit} />
        </PanelHeader.ActionMenu>
      </PanelHeader>
      <div className="pp_no_show_filters-content">
        <InputGroup label="Person">
          <DropDown
            selectedValue={person}
            dataValue={persons}
            onChange={setPerson}
          />
        </InputGroup>
        <InputGroup label="Status">
          <MultiSelectDropdown
            options={statusOptions}
            selected={status}
            selectOption={statusActions.selectOption}
            deselectOption={statusActions.deselectOption}
            clearSelection={statusActions.clearSelection}
          />
        </InputGroup>
        <InputGroup label="Class Type">
          <MultiSelectDropdown
            options={classes}
            selected={classType}
            selectOption={classTypeActions.selectOption}
            deselectOption={classTypeActions.deselectOption}
            clearSelection={classTypeActions.clearSelection}
          />
        </InputGroup>
      </div>
    </div>
  );
};

export default FiltersMenu;

FiltersMenu.propTypes = {
  filters: PropTypes.shape({
    person: PropTypes.string,
    classType: PropTypes.arrayOf(PropTypes.string),
    status: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  applyFilters: PropTypes.func.isRequired,
  closeMenu: PropTypes.func.isRequired,
  persons: PropTypes.arrayOf(PropTypes.object).isRequired,
  classes: PropTypes.arrayOf(PropTypes.object).isRequired,
};
